/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_Signing_OutInputs */



/**
* | output |
* | --- |
* | "Signing you out…" |
*
* @param {Logout_Signing_OutInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const logout_signing_out = /** @type {((inputs?: Logout_Signing_OutInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_Signing_OutInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je wordt afgemeld…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déconnexion en cours…")
	return /** @type {LocalizedString} */ ("Signing you out…")
});